import { useComponentState } from "../../../utils/customHook.util";
import { Flex, FlexInline } from "../Flex";
import Icon from "../Icon";
import "./Fold.css";

type FoldProps = {
    title: string;
    titleChildren: React.JSX.Element | React.JSX.Element[];
    children: React.JSX.Element | React.JSX.Element[];
    openByDefault?: boolean;
};

type FoldState = {
    isOpen: boolean;
};

function Fold(props: FoldProps) {
    const { title, titleChildren, children, openByDefault = false } = props;
    const { state, setState } = useComponentState<FoldState>({
        isOpen: openByDefault,
    });

    return (
        <Flex.Column gap="medium" className="fold">
            <Flex.Row
                className="fold__title"
                gap="large"
                alignItems="center"
                onClick={() => {
                    setState({ isOpen: !state.isOpen });
                }}
            >
                <FlexInline gap="medium">
                    {state.isOpen ? (
                        <Icon.ExpandMore.Medium.N10 />
                    ) : (
                        <Icon.ChevronRight.Medium.N10 />
                    )}

                    <h3>{title}</h3>
                </FlexInline>

                <div>
                    <Flex.Row gap="medium">{titleChildren}</Flex.Row>
                </div>
            </Flex.Row>

            {state.isOpen && (
                <Flex.Column gap="medium" className="fold__content">
                    {children}
                </Flex.Column>
            )}
        </Flex.Column>
    );
}

export default Fold;
